class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.submenu = this.mainDetailsToggle?.querySelector('.header__submenu-large');
    this.sectionHeader = document.querySelector('.section-header');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onToggle() {
    if (!this.submenu) return;

    if (this.mainDetailsToggle.open) {
      requestAnimationFrame(() => this.bindSubmenuPositioning());
    } else {
      this.unbindSubmenuPositioning();
    }
  }

  bindSubmenuPositioning() {
    if (!this.sectionHeader?.classList.contains('scrolled-past-header')) {
      this.unbindSubmenuPositioning();
      return;
    }

    this.submenu.classList.add('header__submenu-large--fixed');
    this.updateSubmenuPosition();
    this.boundUpdateSubmenuPosition = this.onScrollOrResize.bind(this);
    window.addEventListener('scroll', this.boundUpdateSubmenuPosition, { passive: true });
    window.addEventListener('resize', this.boundUpdateSubmenuPosition, { passive: true });
  }

  onScrollOrResize() {
    if (!this.mainDetailsToggle.open) return;

    if (!this.sectionHeader?.classList.contains('scrolled-past-header')) {
      this.unbindSubmenuPositioning();
      return;
    }

    this.submenu.classList.add('header__submenu-large--fixed');
    this.updateSubmenuPosition();
  }

  updateSubmenuPosition() {
    if (!this.sectionHeader || !this.submenu) return;

    const top = this.sectionHeader.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--header-subnav-top', `${top}px`);
  }

  unbindSubmenuPositioning() {
    if (!this.submenu) return;

    this.submenu.classList.remove('header__submenu-large--fixed');
    document.documentElement.style.removeProperty('--header-subnav-top');

    if (!this.boundUpdateSubmenuPosition) return;

    window.removeEventListener('scroll', this.boundUpdateSubmenuPosition);
    window.removeEventListener('resize', this.boundUpdateSubmenuPosition);
    this.boundUpdateSubmenuPosition = null;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.unbindSubmenuPositioning();
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
